import types from './types';

const INITIAL_STATE = {
  isFetchingList: false,
  isFetchingListGroup: false,

  result: [],
};

const authListReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_AUTH_LIST_REQUEST:
        return {
            ...state,
            result: [],
            isFetchingList: true,
        };

    case types.GET_AUTH_LIST_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isFetchingList: false,
        };

    case types.GET_AUTH_LIST_FAILURE:
        return {
            ...state,
            result: [],
            isFetchingList: false,
        };

    case types.GET_AUTH_LIST_GROUP_REQUEST:
        return {
            ...state,
            result: [],
            isFetchingListGroup: true,
        };

    case types.GET_AUTH_LIST_GROUP_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isFetchingListGroup: false,
        };

    case types.GET_AUTH_LIST_GROUP_FAILURE:
        return {
            ...state,
            result: [],
            isFetchingListGroup: false,
        };

    default:
      return state;
  }
};

export default authListReducer;
